export const DRINKS = [
  {
    label: 'Water',
    value: 'water',
  },
  {
    label: 'Pepsi',
    value: 'pepsi',
  },
  {
    label: 'Coca-Cola',
    value: 'coca cola',
  },
];
